/*
  Bothanica Mineral — Decorações de scroll (planta / frasco)

  - Carrega GSAP + ScrollTrigger sob demanda, reusando o mesmo padrão do
    bm-benefits-focus.js (não bloqueia o LCP).
  - Três modos de animação por instância (data-bmsd-mode):
      * parallax        → desloca em Y conforme o scroll (subtle drift)
      * parallax-rotate → parallax em Y + leve rotação (planta lateral)
      * hero            → reveal pinado: fade + scale-up + drift; ideal para o frasco
  - Respeita prefers-reduced-motion: mantém a imagem visível e estática.
  - Idempotente: só inicializa uma vez por elemento.
  - Falha silenciosa: se o GSAP não carregar, a imagem fica visível em estado base.
*/
(function () {
  if (window.__bmScrollDecorInit) return;
  window.__bmScrollDecorInit = true;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start() {
    var nodes = document.querySelectorAll('[data-bmsd]');
    if (!nodes.length) return;

    function revealStatic(n) {
      var img = n.querySelector('.bmsd__img');
      if (!img) return;
      img.style.opacity = n.getAttribute('data-bmsd-opacity') || '1';
      // Preserva o flip via CSS (classe .bmsd--flip já aplica scaleX(-1)).
    }

    // Sem movimento: revela tudo no estado base e encerra.
    if (prefersReduced) {
      nodes.forEach(revealStatic);
      return;
    }

    loadGsap(function (ok) {
      if (!ok || !window.gsap || !window.ScrollTrigger) {
        // Fallback: mostra estático (com flip preservado via CSS).
        nodes.forEach(revealStatic);
        return;
      }
      var gsap = window.gsap;
      gsap.registerPlugin(window.ScrollTrigger);

      nodes.forEach(function (node) {
        if (node.__bmsdDone) return;
        node.__bmsdDone = true;

        var mode = node.getAttribute('data-bmsd-mode') || 'parallax';
        var img = node.querySelector('.bmsd__img');
        if (!img) return;

        var targetOpacity = parseFloat(
          node.getAttribute('data-bmsd-opacity') || '1'
        );
        var driftPx = parseInt(
          node.getAttribute('data-bmsd-drift') || '80',
          10
        );
        var rotateDeg = parseFloat(
          node.getAttribute('data-bmsd-rotate') || '0'
        );
        var isFlipped = node.getAttribute('data-bmsd-flip') === '1';
        var scaleX = isFlipped ? -1 : 1;

        // Tira o flip do CSS (transform inline) para que o GSAP controle
        // o transform completo sem conflito. Aplica via scaleX no GSAP.
        if (isFlipped) img.style.transform = '';

        if (mode === 'hero') {
          // Reveal cinematográfico: estado inicial escondido, anima ao entrar.
          gsap.set(img, {
            autoAlpha: 0,
            scale: 0.78,
            scaleX: 0.78 * scaleX,
            y: 40,
            rotate: rotateDeg
          });

          gsap.to(img, {
            autoAlpha: targetOpacity,
            scale: 1,
            scaleX: scaleX,
            y: 0,
            rotate: 0,
            duration: 1.1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: node,
              start: 'top 80%',
              toggleActions: 'play none none reverse'
            }
          });

          // Parallax sutil contínuo após o reveal.
          gsap.to(img, {
            y: -driftPx,
            ease: 'none',
            scrollTrigger: {
              trigger: node,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1
            }
          });
        } else {
          // Modo parallax / parallax-rotate.
          // Mantém visível em estado base; só anima o transform conforme scroll.
          gsap.set(img, { opacity: targetOpacity, scaleX: scaleX });

          var toVars = {
            y: -driftPx,
            scaleX: scaleX,
            ease: 'none',
            scrollTrigger: {
              trigger: node,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1
            }
          };

          if (mode === 'parallax-rotate' && rotateDeg !== 0) {
            toVars.rotate = rotateDeg;
          }

          gsap.fromTo(
            img,
            { y: driftPx * 0.6, rotate: -rotateDeg * 0.5, scaleX: scaleX },
            toVars
          );
        }
      });
    });
  }

  function loadGsap(cb) {
    if (window.gsap && window.ScrollTrigger) return cb(true);

    var core = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var st =
      'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

    inject(core, function (okCore) {
      if (!okCore) return cb(false);
      inject(st, function (okSt) {
        cb(okSt);
      });
    });
  }

  function inject(src, done) {
    var existing = document.querySelector('script[src="' + src + '"]');
    if (existing) {
      if (existing.dataset.loaded === 'true') return done(true);
      existing.addEventListener('load', function () {
        done(true);
      });
      existing.addEventListener('error', function () {
        done(false);
      });
      return;
    }
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = function () {
      s.dataset.loaded = 'true';
      done(true);
    };
    s.onerror = function () {
      done(false);
    };
    document.head.appendChild(s);
  }

  // Dispara start() apenas quando uma seção [data-bmsd] se aproxima da viewport,
  // evitando baixar o GSAP no window.load para quem nunca rola até as decorações.
  // Mantém o comportamento anterior em reduced-motion e em navegadores sem IO.
  function boot() {
    if (prefersReduced || !('IntersectionObserver' in window)) {
      start();
      return;
    }

    var nodes = document.querySelectorAll('[data-bmsd]');
    if (!nodes.length) return;

    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          obs.disconnect();
          start();
          return;
        }
      }
    }, { rootMargin: '400px 0px' });

    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot, { once: true });
  }
})();
